export default __webpack_public_path__ + "static/media/volunteer.2848cf56.png";